export const tasks = {
  // Page titles
  title: 'Tasks',
  subtitle: 'Manage and track tasks',
  create: 'New Task',
  createTask: 'Create New Task',
  edit: 'Edit Task',
  editTask: 'Edit Task',
  delete: 'Delete Task',

  // Sections
  sections: {
    basicInfo: 'Basic Information',
    description: 'Description',
    assignment: 'Assignment',
    timeEstimation: 'Time Estimation',
    timeEstimate: 'Time Estimation',
    tags: 'Tags',
    timeCompletion: 'Timing and Completion',
    assignmentClient: 'Assignment and Client',
    tagsWork: 'Tags and Work'
  },

  // Fields
  fields: {
    taskNumber: 'Task Number',
    title: 'Task Name',
    description: 'Description',
    priority: 'Priority',
    status: 'Status',
    assignedTo: 'Assigned To',
    customer: 'Customer',
    project: 'Project',
    dueDate: 'Due Date (date and time)',
    completedDate: 'Completed Date',
    estimatedHours: 'Estimated Hours',
    actualHours: 'Actual Hours',
    tags: 'Tags',
    documents: 'Documents',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    createdBy: 'Created By'
  },

  // Priorities
  priority: {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    urgent: 'Urgent'
  },

  // Statuses
  status: {
    todo: 'To Do',
    in_progress: 'In Progress',
    completed: 'Completed',
    cancelled: 'Cancelled'
  },

  // Placeholder texts
  placeholders: {
    taskTitle: 'Enter task title',
    taskDescription: 'Detailed task description...',
    assignedTo: 'Assignee name or email',
    selectCustomer: 'Select customer...',
    selectProject: 'Select project...',
    selectAssignee: 'Select assignee...',
    searchCustomer: 'Search customers...',
    searchProject: 'Search projects...',
    searchAssignee: 'Search users...',
    noCustomersFound: 'No customers found',
    noProjectsFound: 'No projects found',
    noAssigneesFound: 'No users found',
    addTag: 'Add new tag...',
    documents: 'Attach documents related to the task',
    searchTasks: 'Search tasks...',
    searchPlaceholder: 'Search...',
    noResults: 'No results found'
  },

  // Actions
  actions: {
    newTask: 'New Task',
    createFirstTask: 'Create first task',
    addTag: 'Add',
    viewTask: 'View',
    editTask: 'Edit',
    deleteTask: 'Delete',
    assignToMe: 'Assign to me',
    unassign: 'Unassign',
    markCompleted: 'Mark as completed',
    markInProgress: 'Mark as in progress'
  },

  // Filters
  filters: {
    all: 'All',
    dueToday: 'Due today',
    dueThisWeek: 'Due this week',
    overdue: 'Overdue'
  },

  // Statistics
  stats: {
    totalTasks: 'Total tasks',
    todoTasks: 'To do',
    inProgressTasks: 'In progress',
    completedTasks: 'Completed',
    overdueTasks: 'Overdue',
    myTasks: 'My tasks',
    completionRate: 'Completion rate'
  },

  // Messages
  messages: {
    loadingTasks: 'Loading tasks...',
    noTasks: 'No tasks yet',
    noTasksInProject: 'No tasks in this project',
    noTasksFound: 'No tasks found',
    createSuccess: 'Task created successfully!',
    createError: 'Error occurred while creating task',
    updateSuccess: 'Task updated successfully!',
    updateError: 'Error occurred while updating task',
    deleteSuccess: 'Task deleted successfully!',
    deleteError: 'Error occurred while deleting task',
    assignSuccess: 'Task assigned successfully!',
    assignError: 'Error occurred while assigning task',
    unassignSuccess: 'Assignment removed successfully!',
    statusUpdateSuccess: 'Status updated successfully!',
    statusUpdateError: 'Error occurred while updating status',
    priorityUpdateSuccess: 'Priority updated successfully!',
    priorityUpdateError: 'Error occurred while updating priority',
    confirmDelete: 'Are you sure you want to delete this task?',
    overdue: 'Overdue',
    dueToday: 'Due today',
    dueSoon: 'Due soon',
    dueInDays: 'Due in {{days}} days'
  },

  // Validation messages
  validation: {
    titleRequired: 'Task title is required',
    estimatedHoursMin: 'Estimated hours cannot be negative',
    actualHoursMin: 'Actual hours cannot be negative'
  }
}; 